/*
Controllers Index:
  Accounts
  Ai
  Applications
  Analytics
  BulkImport
  InventoryIngestion
  InventoryIngestionBinaries
  InventoryIngestionSubmissions
  InventoryIngestionDownloads
  Bundles
  Categories
  ChangePassword
  Contract
  Conversionrates
  Impersonate
  Users
  Designers
  Families
  Foundry
  UserManagement
  Submissions
  Login
  Payments
  Profile
  Promotions
  QuarterlyReportsProject
  QuarterlyRoyaltiesStatements
  SalesReport
  SecretCode
  Settings
  Binaries
  Downloads
  Images
  SubmissionMessages
  PackageSuggestions
  Asset
  FoundryHealth
  Jwt
  MfpNumbers
  FeatureAgreements
  DropShip
*/
var controllers = {}
var controllerNames = []

controllerNames.push('Accounts')
controllerNames.push('Ai')
controllerNames.push('Applications')
controllerNames.push('Analytics')
controllerNames.push('BulkImport')
controllerNames.push('InventoryIngestion')
controllerNames.push('InventoryIngestionBinaries')
controllerNames.push('InventoryIngestionSubmissions')
controllerNames.push('InventoryIngestionDownloads')
controllerNames.push('Bundles')
controllerNames.push('Categories')
controllerNames.push('ChangePassword')
controllerNames.push('Contract')
controllerNames.push('Conversionrates')
controllerNames.push('Impersonate')
controllerNames.push('Users')
controllerNames.push('Designers')
controllerNames.push('Families')
controllerNames.push('Foundry')
controllerNames.push('UserManagement')
controllerNames.push('Submissions')
controllerNames.push('Login')
controllerNames.push('Payments')
controllerNames.push('Profile')
controllerNames.push('Promotions')
controllerNames.push('QuarterlyReportsProject')
controllerNames.push('QuarterlyRoyaltiesStatements')
controllerNames.push('SalesReport')
controllerNames.push('SecretCode')
controllerNames.push('Settings')
controllerNames.push('Binaries')
controllerNames.push('Downloads')
controllerNames.push('Images')
controllerNames.push('SubmissionMessages')
controllerNames.push('PackageSuggestions')
controllerNames.push('Asset')
controllerNames.push('FoundryHealth')
controllerNames.push('Jwt')
controllerNames.push('MfpNumbers')
controllerNames.push('FeatureAgreements')
controllerNames.push('DropShip')

for (var i = 0, l = controllerNames.length; i < l; i++) {
  controllers[controllerNames[i]] = require('./' + controllerNames[i])
}

module.exports = controllers
